export const brandProfiles = [
  {
    id: "hytera",
    name: "Hytera",
    relationship: "distributor" as const,
    tagline: "Professional Body-Worn Cameras, 5G/4G Smart Cameras & Evidence Management",
    category: "Communications & Body Cameras",
    origin: "China (Global HQ: Shenzhen)",
    founded: "1993",
    website: "www.hytera.com",
    icon: "ri-camera-3-line",
    color: "#c8232c",
    coverImage:
      "https://static.readdy.ai/image/8ef50732a893e16bbc98824684ca939c/6361b46f6b477cab14ccdd104183444e.jpeg",
    description:
      "Hytera is a leading global provider of professional body-worn video and communications solutions. With 30+ years of innovation, they deliver purpose-built body-worn cameras including the flagship SC880 5G smart camera with 4K video and 300-second pre-recording, the SC780 4G with 13-hour battery and live streaming, and the compact GC550 — alongside multi-bay docking stations and the DEMS digital evidence management platform. Trusted by law enforcement, government agencies, and security operations across 120+ countries including Malaysia.",
    highlights: [
      "SC880: 5G flagship — 4K video, 300s pre-record, 10-hr battery, IP68, MIL-STD-810G",
      "SC780: 4G LTE smart camera — 1080P, 130° FOV, 13-hr battery, 120s pre-record, IP68",
      "GC550: Compact body camera — 1080P, 8-hr battery, IP67, infrared night vision, AES-256",
      "DEMS platform + multi-bay docking station: full chain-of-custody evidence management",
    ],
    products: [
      {
        name: "SC880 5G Body Camera",
        description: "5G flagship — 4K video, 300s pre/post recording, 10-hr battery, IP68, MIL-STD-810G, dual microphones, AES-256 encrypted.",
        icon: "ri-camera-3-line",
      },
      {
        name: "SC780 4G Body Camera",
        description: "4G LTE smart camera — 1080P, 130° FOV, 6-axis EIS, 13-hr battery, 120s pre-record, IP68, PTT radio, NFC ID switch.",
        icon: "ri-vidicon-line",
      },
      {
        name: "GC550 Body Camera",
        description: "Compact body camera — 1080P, 8-hr battery, IP67, MIL-STD-810G, infrared night vision, AES-256 encryption, 120s pre-record.",
        icon: "ri-camera-line",
      },
    ],
    useCases: ["Law Enforcement", "Government Security Agencies", "Private Security Operations", "Healthcare Security"],
  },
  {
    id: "exagrid",
    name: "ExaGrid",
    relationship: "distributor" as const,
    tagline: "Tiered Backup Storage with Deduplication",
    category: "Data Backup",
    origin: "United States (Marlborough, MA)",
    founded: "2002",
    website: "www.exagrid.com",
    icon: "ri-hard-drive-2-line",
    color: "#d97706",
    coverImage:
      "https://static.readdy.ai/image/8ef50732a893e16bbc98824684ca939c/93145761f0aa55aba9715f6befd286d5.jpeg",
    description:
      "ExaGrid is the world's only purpose-built backup storage solution with a unique tiered landing zone architecture. By keeping the most recent backups in their full, unhydrated form, ExaGrid delivers the fastest backup, restore, and instant recovery times available — while using deduplication and compression to minimize long-term storage costs.",
    highlights: [
      "Patented Tiered Landing Zone for fastest restores",
      "Scale-out architecture — add capacity without forklift upgrades",
      "Integrates with all major backup software (Veeam, Commvault, Veritas, etc.)",
      "Ransomware protection with time-locked delayed deletes",
    ],
    products: [
      {
        name: "EX Series Appliances",
        description: "Scale-out backup appliances from 3TB to 3PB full system capacity with built-in deduplication.",
        icon: "ri-stack-line",
      },
      {
        name: "Tiered Landing Zone",
        description: "Unique architecture that stores recent backups undeduplicated for instant VM recovery.",
        icon: "ri-stack-line",
      },
      {
        name: "ExaGrid Ransomware Shield",
        description: "Immutable backup copies with delayed delete and retention time locks.",
        icon: "ri-shield-keyhole-line",
      },
      {
        name: "EXAGRID Cloud Tier",
        description: "Seamless cloud tiering to AWS, Azure, or Google Cloud for long-term retention.",
        icon: "ri-cloud-line",
      },
    ],
    useCases: ["Healthcare Systems", "Financial Institutions", "Government Agencies", "Enterprise IT"],
  },
  {
    id: "arcfra",
    name: "Arcfra",
    relationship: "distributor" as const,
    tagline: "Enterprise Cloud Platform (AECP) — Gartner-Recognized VMware & Nutanix Alternative",
    category: "Enterprise Cloud Platform (HCI)",
    origin: "Singapore (Headquarters)",
    founded: "2015",
    website: "www.arcfra.com",
    icon: "ri-server-line",
    color: "#374151",
    coverImage:
      "https://static.readdy.ai/image/8ef50732a893e16bbc98824684ca939c/fd49ded05a74814d2db9300752afaf60.png",
    description:
      "Arcfra Enterprise Cloud Platform (AECP) is a full-stack software-defined infrastructure platform converging compute virtualisation (AVE), block storage (ABS), file storage (AFS), Kubernetes (AKE), and network & security (ANS) into one unified system. Recognized by Gartner in the March 2025 VMware Alternative Guide and April 2025 Full-Stack HCI Market Guide as one of 8 worldwide representative vendors. Trusted by 1,000+ enterprise customers globally. Starts from 3 nodes, licensed by CPU core with no vendor lock-in on commodity X86 hardware.",
    highlights: [
      "Gartner March 2025 — \"Guide to Choosing a VMware Alternative in the Wake of Broadcom Acquisition\"",
      "Gartner April 2025 — 1 of 8 worldwide representative vendors for Full-Stack HCI Software",
      "DCIG Top 5 VMware Alternatives — Rising Vendors Edition 2026–27",
      "1,000+ enterprise customers globally — 600+ proved on AVE (Virtualization Engine)",
      "Arcfra Virtualization Engine (AVE): full VM lifecycle, live migration, HA, automatic failover",
      "Arcfra Block Storage (ABS): intra-city active-active (RPO=0), cross-city async DR (RPO ≥15min)",
      "Arcfra Kubernetes Engine (AKE): CNCF conformant, one-click cluster, VM + bare-metal K8s",
      "Neutree AI platform: private Model-as-a-Service, GPU management, model training & inference",
      "Pure software — compatible with commodity X86 servers, no proprietary hardware required",
      "Subscription licensing by CPU core — no per-socket VMware-style fees",
    ],
    products: [
      {
        name: "Arcfra Virtualization Engine (AVE)",
        description: "Enterprise hypervisor with full VM lifecycle management, live migration, HA, and automatic failover. 600+ enterprise customers. Supports VMware ESXi integration and Arcfra Migration Tools.",
        icon: "ri-server-line",
      },
      {
        name: "Arcfra Block Storage (ABS)",
        description: "Software-defined block storage with automatic data tiering, multi-replica redundancy, intra-city active-active clustering (RPO=0, RTO in minutes), and cross-city async replication.",
        icon: "ri-hard-drive-2-line",
      },
      {
        name: "Arcfra Kubernetes Engine (AKE)",
        description: "CNCF Kubernetes conformant managed K8s. One-click cluster creation, VM-based and bare-metal nodes, autoscaling node groups, pre-integrated CNI/Ingress/Monitoring.",
        icon: "ri-cloud-line",
      },
      {
        name: "Arcfra Network Service (ANS) & File Storage (AFS)",
        description: "ANS: distributed firewall, VPC, microsegmentation, load balancing for VMs and containers. AFS: integrated enterprise file storage — no additional hardware cost, 90–120s HA failover.",
        icon: "ri-shield-check-line",
      },
    ],
    useCases: ["VMware Migration", "Nutanix Replacement", "AI & ML Infrastructure", "Cloud-Native & Kubernetes"],
  },
  {
    id: "synology",
    name: "Synology",
    relationship: "technology-partner" as const,
    tagline: "Network-Attached Storage & Cloud Management for Every Scale",
    category: "NAS & Cloud Storage",
    origin: "Taiwan (Taipei)",
    founded: "2000",
    website: "www.synology.com",
    icon: "ri-cloud-line",
    color: "#0284c7",
    coverImage:
      "https://static.readdy.ai/image/8ef50732a893e16bbc98824684ca939c/172079bbdbdd58c70f75b37a5b97049d.jpeg",
    description:
      "Synology has been a trusted name in storage innovation since 2000. From compact desktop NAS units to enterprise rack systems, Synology provides an integrated ecosystem of hardware, software, and cloud services — all managed through their award-winning DiskStation Manager (DSM) operating system. Whether backing up thousands of endpoints or managing a hybrid cloud environment, Synology makes it seamless.",
    highlights: [
      "DiskStation Manager (DSM) — award-winning OS for storage management",
      "C2 Cloud platform for offsite backup and collaboration",
      "Supports CIFS/SMB, NFS, iSCSI, AFP, and more",
      "Active Backup Suite — agentless backup for VMs, Microsoft 365, and endpoints",
    ],
    products: [
      {
        name: "DiskStation DS1823xs+",
        description: "8-bay NAS with 10GbE, PCIe expansion, and enterprise-grade performance for SMBs.",
        icon: "ri-hard-drive-2-line",
      },
      {
        name: "RackStation RS2423+",
        description: "12-bay rack-mount NAS ideal for centralised file server and backup consolidation.",
        icon: "ri-server-line",
      },
      {
        name: "Active Backup for Business",
        description: "Agentless backup for VMs, Microsoft 365, Google Workspace, and physical endpoints.",
        icon: "ri-shield-flash-line",
      },
      {
        name: "Synology C2 Cloud",
        description: "Secure offsite cloud backup with immutable snapshots and global compliance.",
        icon: "ri-cloud-line",
      },
    ],
    useCases: ["SMB File Servers", "Endpoint Backup", "Virtual Machine Backup", "Surveillance NAS"],
  },
  {
    id: "honeywell",
    name: "Honeywell",
    relationship: "technology-partner" as const,
    tagline: "Enterprise Rugged Tablets & Mobile Computers for Field & Industrial Operations",
    category: "Rugged Mobile Devices",
    origin: "United States (Charlotte, NC)",
    founded: "1906",
    website: "www.honeywell.com/sensing-productivity",
    icon: "ri-smartphone-line",
    color: "#dc2626",
    coverImage:
      "https://static.readdy.ai/image/8ef50732a893e16bbc98824684ca939c/681902d91e349a96ea742ac635d1fc04.jpeg",
    description:
      "Honeywell's Productivity Solutions and Services division is a global leader in enterprise-grade rugged tablets and mobile computers. Their rugged tablet lineup — including the ScanPal EDA10A and RT10 series — is purpose-built for warehousing, logistics, field service, and industrial operations, delivering MIL-STD-810G/H durability, integrated scanning, and long-term Android and Windows OS support through the Honeywell Mobility Edge platform.",
    highlights: [
      "ScanPal EDA10A: 10-inch Android 12→14 tablet — 8,000mAh hot-swap battery, 674g, Gorilla Glass 5, 5G + Wi-Fi 6, Qualcomm Snapdragon Octa-Core 2.2GHz, IP65, MIL-STD-810G",
      "RT10A Android: Android 9→13 (committed to 14), FlexRange scanner 0.1m–10.7m, 5,900mAh (12hr) or 10,280mAh (18hr) hot-swap battery, 4G LTE CAT13 up to 400Mbps, NFC, BT 5.0",
      "RT10W Windows: Windows 10 Enterprise LTSC, Intel Pentium N4200 up to 2.5GHz, 8GB/128GB, FlexRange scanner, 4G LTE CAT6, TPM v2.0, Kensington Lock, vehicle dock ready",
      "Honeywell Mobility Edge™ — unified platform for long-term Android OS lifecycle management (Android 9 through 14 committed)",
      "MIL-STD-810G/H and IP65 certified across the rugged tablet lineup — built for warehouse, field, and vehicle environments",
      "Vehicle dock compatible — Honeywell vehicle dock, desk dock, and quad bay battery charger accessories available",
    ],
    products: [
      {
        name: "ScanPal EDA10A Tablet",
        description: "10-inch Android 11 enterprise tablet with 5G, Wi-Fi 6, integrated 2D barcode scanner, IP65, and 7600mAh all-day battery.",
        icon: "ri-tablet-line",
      },
      {
        name: "RT10 Rugged Tablet — Android",
        description: "10-inch Android rugged tablet with hot-swappable battery, vehicle dock support, MIL-STD-810G, IP65, and optional LTE.",
        icon: "ri-smartphone-line",
      },
      {
        name: "RT10 Rugged Tablet — Windows",
        description: "10-inch Windows 10 IoT Enterprise rugged tablet — runs full desktop apps, glove-touch, hot-swap battery, vehicle dock ready.",
        icon: "ri-computer-line",
      },
      {
        name: "Honeywell Mobility Edge",
        description: "Unified device management platform providing long-term Android OS support, remote management, and security policy enforcement.",
        icon: "ri-settings-3-line",
      },
    ],
    useCases: ["Warehouse & Logistics", "Manufacturing & Industrial", "Field Service Operations", "Fleet & Vehicle Computing"],
  },
  {
    id: "dell-rugged",
    name: "Dell Rugged Pro",
    relationship: "technology-partner" as const,
    tagline: "World's Smallest & Lightest Fully-Rugged AI PCs — MIL-STD-810H Certified",
    category: "Rugged Laptops & Tablets",
    origin: "United States (Round Rock, TX)",
    founded: "1984",
    website: "www.dell.com/rugged",
    icon: "ri-macbook-line",
    color: "#374151",
    coverImage:
      "https://static.readdy.ai/image/8ef50732a893e16bbc98824684ca939c/f0f8b16956d73016f051062d0e8c7ffc.jpeg",
    description:
      "Dell Pro Rugged is the world's leading portfolio of fully-rugged and semi-rugged AI PCs — engineered for the most demanding field environments. The lineup spans the ultra-portable 10-inch Pro Rugged 10 Tablet (world's lightest 10\" fully-rugged Windows tablet at 1.04kg) through to the powerful 14-inch Pro Rugged 14 laptop. All devices are powered by Intel Core Ultra 200V series processors with Copilot+ AI capabilities, certified to MIL-STD-810H, and feature hot-swappable batteries, sunlight-readable glove-touch displays, and optional 5G connectivity.",
    highlights: [
      "Dell Pro Rugged 10 Tablet: World's lightest 10\" fully-rugged Windows tablet — 1.04kg, IP66, Intel Core Ultra 200V, Wi-Fi 7, optional 5G",
      "Dell Pro Rugged 12 Tablet: 1200-nit sunlight-readable display, dual hot-swap batteries, Intel Core Ultra 200V, Wi-Fi 7, optional 5G",
      "Dell Pro Rugged 13 Laptop: World's smallest 13\" fully-rugged AI PC — 1400-nit screen, IP65, 6ft drop-tested, optional 5G",
      "Dell Pro Rugged 14 Laptop: World's smallest & lightest 14\" semi-rugged AI PC — optional NVIDIA RTX 500 Ada Gen, 1100-nit, IP53",
      "Intel Core Ultra 200V series with 40+ TOPS NPU — Copilot+ AI PC capabilities across the full lineup",
      "EPEAT Gold, ENERGY STAR, EPEAT Climate+ certified — built with recycled materials",
    ],
    products: [
      {
        name: "Dell Pro Rugged 10 Tablet",
        description: "World's lightest 10\" fully-rugged Windows tablet at 1.04kg. IP66, Intel Core Ultra 200V, 1000-nit sunlight-readable, Wi-Fi 7, optional 5G, hot-swappable battery, FirstNet Ready.",
        icon: "ri-tablet-line",
      },
      {
        name: "Dell Pro Rugged 12 Tablet",
        description: "12\" fully-rugged tablet with 1200-nit glove-touch display, dual hot-swappable batteries, Intel Core Ultra 200V, Wi-Fi 7, optional 5G, Copilot+ AI PC.",
        icon: "ri-tablet-line",
      },
      {
        name: "Dell Pro Rugged 13 Laptop",
        description: "World's smallest 13\" fully-rugged AI PC. 1400-nit low-blue-light screen, IP65, 6ft drop-tested, -20°F to 145°F operating range, resistive touchpad, optional 5G.",
        icon: "ri-macbook-line",
      },
      {
        name: "Dell Pro Rugged 14 Laptop",
        description: "World's smallest & lightest 14\" semi-rugged AI PC. Intel Core Ultra with optional NVIDIA RTX 500 Ada Gen, 1100-nit display, IP53, 3ft drop-tested, hot-swappable batteries, optional 5G.",
        icon: "ri-computer-line",
      },
    ],
    useCases: ["Military & Defence", "Field Engineering & Utilities", "First Responders & Public Safety", "Construction & Infrastructure"],
  },
];
